import type { TypographyOptions } from "@mui/material/styles/createTypography";

declare module "@mui/material/styles" {
    interface TypographyVariants {
        kpiValue: React.CSSProperties;
        kpiLabel: React.CSSProperties;
    }

    interface TypographyVariantsOptions {
        kpiValue?: React.CSSProperties;
        kpiLabel?: React.CSSProperties;
    }
}

// Allow usage in <Typography variant="...">
declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        kpiValue: true;
        kpiLabel: true;
    }
}

export const typography = {
    fontFamily:
        '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    body1: { fontSize: "1rem", fontWeight: 400, lineHeight: 1.5 },
    body2: { fontSize: "0.875rem", fontWeight: 400, lineHeight: 1.57 },
    button: { fontWeight: 500 },
    caption: { fontSize: "0.75rem", fontWeight: 400, lineHeight: 1.66 },
    subtitle1: { fontSize: "1rem", fontWeight: 500, lineHeight: 1.57 },
    subtitle2: { fontSize: "0.875rem", fontWeight: 500, lineHeight: 1.57 },
    overline: {
        fontSize: "0.75rem",
        fontWeight: 500,
        letterSpacing: "0.5px",
        lineHeight: 2.5,
        textTransform: "uppercase",
    },
    h1: { fontSize: "3.5rem", fontWeight: 500, lineHeight: 1.2 },
    h2: { fontSize: "3rem", fontWeight: 500, lineHeight: 1.2 },
    h3: { fontSize: "2.25rem", fontWeight: 500, lineHeight: 1.2 },
    h4: { fontSize: "2rem", fontWeight: 500, lineHeight: 1.2 },
    h5: { fontSize: "1.5rem", fontWeight: 500, lineHeight: 1.2 },
    h6: { fontSize: "1.125rem", fontWeight: 500, lineHeight: 1.2 },
    kpiValue: {
        fontWeight: 600,
        fontSize: 'clamp(1rem, 1vw + 0.9rem, 1.4rem)',
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'center',
    },

    kpiLabel: {
        fontSize: 'clamp(0.85rem, 1vw, 0.75rem)',
        color: '#777', // or  theme.palette.text.secondary later
        textAlign: 'center',
        lineHeight: 1.4,
    },
} satisfies TypographyOptions;
